
import React, { useEffect, useState } from "react";
import { Routes } from "../../constants";
import { Link, useNavigate } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";
import ReactPaginate from "react-paginate";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { routes } from "../../constants/routes";
import AddKeyValue from "./AddKeyValue";
// import FormVideoSop from "./FormVideoSop";

const KeyValue = (props) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const role = localStorage.getItem("userRole");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const rowsPerPage = 10;
  // const offset = currentPage * rowsPerPage;
  // let paginatedData = [];
  // try {
  //   if (Array.isArray(filteredData)) {
  //     paginatedData = filteredData.slice(offset, offset + rowsPerPage);
  //   } else {
  //     throw new Error("filteredData is not an array");
  //   }
  // } catch (exception) {
  //   paginatedData = [];
  //   console.log(exception);
  // }
  const searchedData = filteredData.filter(
    (item) =>
      item.key?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.value?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const offset = currentPage * rowsPerPage;
  const paginatedData = searchedData.slice(
    offset,
    offset + rowsPerPage
  );
  
  useEffect(() => {
    getKeyValue();
  }, [props.admin.loadingKeyValue]);
  const getKeyValue = async () => {
    try {
      const response = await props.admin.getAllKeyVAlue();
      props.application.setLoading(true);
      if (response.success) {
        setFilteredData(response.data);
        props.application.setLoading(false);
      } else {
        toast.error("Failed to fetch data", {
          position: toast.POSITION.TOP_CENTER,
        });
        props.application.setLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      props.application.setLoading(false);
      console.error("Error occured :", error);
    }
  };
  const handleDeleteKeyValue = async (id) => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          props.application.setLoading(true);
          const res = await props.admin.deleteKeyValue(id);
          if (res.success === true) {
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            getKeyValue();
            props.application.setLoading(false);
          } else {
            props.application.setLoading(false);
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        } catch (error) {
          console.log(error);
          props.application.setLoading(false);
          toast.dismiss();
          toast.success("Something went wrong!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    });
  };
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (selected === pageCount - 1 || pageCount === 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };
  const renderPagination = () => {
    const pageCount = Math.ceil(searchedData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageClassName={"page-item"}
          pageCount={pageCount}
          pageRangeDisplayed={0}
          marginPagesDisplayed={2}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          breakLabel="..."
          previousLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillLeftCircle />
            </IconContext.Provider>
          }
          nextLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillRightCircle />
            </IconContext.Provider>
          }
          renderOnZeroPageCount={null}
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };
  // const handleInputChange = (index, field, value) => {
  //   // index is the index inside paginatedData
  //   const globalIndex = currentPage * rowsPerPage + index;
  
  //   const updated = [...filteredData];
  //   updated[globalIndex][field] = value;
  
  //   setFilteredData(updated);
  // };
  
  const handleInputChange = (index, field, value) => {
    const globalIndex = currentPage * rowsPerPage + index;
  
    const updated = [...filteredData];
    updated[globalIndex][field] = value;
  
    setFilteredData(updated);
  
    // 🔥 Real-time validation
    setErrors((prev) => ({
      ...prev,
      [updated[globalIndex].id]: {
        ...prev[updated[globalIndex].id],
        [field]: !value.trim() ? "Required" : "",
      },
    }));
  };
  
  const handleSave =async (item) => {
    if (!item.key || item.key.trim() === "") {
      toast.error("Key is required!", { position: "top-center" });
      return;
    }
  
    if (!item.value || item.value.trim() === "") {
      toast.error("Value is required!", { position: "top-center" });
      return;
    }
    try {
      const data={ 
        key: item.key, 
        value: item.value 
      }
      const response = await props.admin.updateKeyValue(item.id,data );
      props.application.setLoading(true);
      if (response.success) {
        getKeyValue();
        toast.success(response.message || "Updated successfully!",{
          position: toast.POSITION.TOP_CENTER,
        })
        props.application.setLoading(false);
      } else {
        toast.error("Failed to fetch data", {
          position: toast.POSITION.TOP_CENTER,
        });
        props.application.setLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      props.application.setLoading(false);
      console.error("Error occured :", error);
    }
  };
  const listA = filteredData.filter(
    (item) =>
     
      item.key
        ?.toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
        item.value
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) 
  );

  
  return (
    <main id="main" className="main">
      <div className="pagetitle mb-3">
        <h1>key / value Mangement</h1>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={Routes.DASHBOARD}>Home</Link>
            </li>
            <li className="breadcrumb-item active">key / value Mangement</li>
          </ol>
        </nav>
      </div>
      <section className="section dashboard">
        <div className="row">
          <div className="col-12">
            <div className="card recent-sales overflow-auto">
              <div className="card-body p-3">
                <div className="data-se">
                  <div className="d-flex justify-content-between">
                    <div>
                      <a
                        href="#"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Add key / value
                      </a>
                    </div>
                    <div>
            <input type="text" className="form-control mb-2" placeholder="Search key/value" value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value);
    setCurrentPage(0); // 🔥 reset to first page on search
  }}
/>
          </div>
                  </div>
                  <div className="tab-content pt-2" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                  <table className="table table-bordered">
  <thead>
    <tr>
      <th>Key</th>
      <th>Value</th>
      <th>Action</th>
    </tr>
  </thead>

  <tbody>
    {paginatedData && paginatedData.length > 0 ? (
      paginatedData.map((item, index) => (
        <tr key={item.id}>
          
          {/* Editable Key */}
          <td>
            <input
              type="text"
              // className="form-control"
              className={`form-control ${errors[item.id]?.key ? "error-border" : ""}`}
              value={item.key}
              onChange={(e) =>
                handleInputChange(index, "key", e.target.value)
              }
            />
          </td>

          {/* Editable Value */}
          <td>
            <input
              type="text"
              // className="form-control"
              className={`form-control ${errors[item.id]?.value ? "error-border" : ""}`}
              value={item.value}
              onChange={(e) =>
                handleInputChange(index, "value", e.target.value)
              }
            />
          </td>

          <td>
            <button
              className="btn btn-success btn-sm"
              onClick={() => handleSave(item)}
            >
              Save
            </button>

            <button
              className="btn btn-danger btn-sm ms-2"
              onClick={() => handleDeleteKeyValue(item.id)}
            >
              <i className="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="3" className="text-center">
          No results found!
        </td>
      </tr>
    )}
  </tbody>
</table>

                      {
                        <div className="table-footer">
                          <strong>Total Count: {searchedData.length}</strong>
                          {renderPagination()}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AddKeyValue/>
    </main>
  );
};
export default injectModels(["admin", "application"])(KeyValue);
